import { FC, useEffect, useState } from 'react';
import { Form, FormikProvider, useFormik } from 'formik';
import cn from 'classnames';

import { Button, Checkbox, FormikRadioGroup, Icon, FormikInputNumber, Radio, Text } from 'shared/components/ui';

import styles from './index.module.scss';

interface Props {
	className?: string;
	controls: {
		main: {
			togglePage: () => void;
			count: number;
			isAllSelected: boolean;
		};
		extra?: {
			selectPage: () => void;
			selectAll: () => void;
			selectCount: (count: number) => void;
			clearSelection: () => void;
		};
	};
	hint?: string;
	total?: number;
}

function formatNumberWithCommas(number: number) {
	return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

type SelectEditForm = {
	type: 'select' | 'select_page' | 'select_all';
	number?: number;
};

export const TableSelectionV2: FC<Props> = ({ className, hint, controls, total }) => {
	const [isSelectOpen, setIsSelectOpen] = useState(false);

	const { togglePage, isAllSelected, count } = controls.main;

	const formik = useFormik<SelectEditForm>({
		initialValues: { type: 'select', number: 20 },
		onSubmit: values => {
			console.log(values);
			if (values.type === 'select_all') {
				controls.extra?.selectAll();
			}
			if (values.type === 'select_page') {
				controls.extra?.selectPage();
			}
			if (values.type === 'select') {
				console.log(values.number === 0);
				if (values.number === 0) {
					console.log('yo');
					controls.extra?.clearSelection();
				} else {
					controls.extra?.selectCount(values.number!);
				}
			}
			setIsSelectOpen(false);
		}
	});

	const handleDecreaseNumber = () => {
		formik.setFieldValue('number', Math.max((formik.values.number || 0) - 1, 0));
	};

	const handleIncreaseNumber = () => {
		formik.setFieldValue('number', Math.min((formik.values.number || 0) + 1, total!));
	};

	const handleCancel = () => {
		setIsSelectOpen(false);
	};

	useEffect(() => {
		if (formik.values.type !== 'select') {
			formik.setFieldValue('type', 'select');
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [formik.values.number]);

	return (
		<FormikProvider value={formik}>
			<Form>
				<div className={cn(styles.selectWrapper, className)}>
					<Checkbox onChange={togglePage} checked={isAllSelected} />
					<div className={styles.inline}>
						<Text color={count === 0 ? 'grey' : 'black'}>
							{count === 0 ? hint : `${formatNumberWithCommas(count)} Selected`}
						</Text>
						{controls.extra && (
							<>
								<div className={cn(styles.menuWrapper, { [styles.hidden]: !isSelectOpen })}>
									<div className={styles.menu}>
										<FormikRadioGroup className={styles.group} name="type">
											<div className={styles.vertical}>
												<Radio value="select">
													<div className={styles.menuSelection}>
														<Text component="p" color="black" className={styles.menuSelect}>
															Select number of people
														</Text>
													</div>
												</Radio>
												<div className={styles.numberWrapper}>
													<div
														className={cn(styles.numberIcon, styles.numberIconLeft)}
														onClick={handleDecreaseNumber}>
														<Icon icon="minus" size={20} />
													</div>
													<FormikInputNumber
														controls={false}
														name="number"
														className={styles.menuInput}
													/>
													<div
														className={cn(styles.numberIcon, styles.numberIconRight)}
														onClick={handleIncreaseNumber}>
														<Icon icon="plus-big" size={20} />
													</div>
												</div>
												<Radio value="select_page">
													<Text component="p" color="black" className={styles.menuSelect}>
														Select this page (20)
													</Text>
												</Radio>
												<Radio value="select_all">
													<Text component="p" color="black" className={styles.menuSelect}>
														Select all {total ? `(${formatNumberWithCommas(total)})` : ''}
													</Text>
												</Radio>
											</div>
										</FormikRadioGroup>

										<div className={styles.buttons}>
											<Button type="ghost" htmlType="button" onClick={handleCancel}>
												Cancel
											</Button>
											<Button type="blue" onClick={formik.submitForm}>
												Apply
											</Button>
										</div>
									</div>
								</div>
								<div
									className={styles.selectTriggerWrapper}
									onClick={() => {
										setIsSelectOpen(!isSelectOpen);
									}}>
									<Icon
										className={cn(styles.selectTrigger, {
											[styles.selectTriggerOpen]: isSelectOpen
										})}
										icon="chevron"
									/>
								</div>
							</>
						)}
					</div>
				</div>
			</Form>
		</FormikProvider>
	);
};
